import axios from "@/plugins/axios";

let url = "/api/v1/shop/inquires";

export default {
    getInquires(data){
        return axios.get(url, data).then(result => result.data);
    },
}
